import { render, staticRenderFns } from "./ReporteTendenciaRendimiento.vue?vue&type=template&id=35674688&"
import script from "./ReporteTendenciaRendimiento.vue?vue&type=script&lang=js&"
export * from "./ReporteTendenciaRendimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports